<template>
  <div class="login-bridge">
    <i class="el-icon-loading loading-icon"></i>
    <p class="loading-text">{{ loadingText }}</p>
  </div>
</template>

<script>
import { setSession } from "@/util/localStor";
import { basicLoad, areaList } from "@/api/zd";

export default {
  name: "LoginBridge",
  data() {
    return {
      loadingText: "正在跳转登录，请稍候..."
    };
  },
  mounted() {
    this.consumeBridgeLogin();
  },
  methods: {
    async consumeBridgeLogin() {
      const bridgeKey = this.$route.query.bridgeKey;
      if (!bridgeKey) {
        this.handleBridgeError("缺少跳转登录凭证，请重新发起操作");
        return;
      }
      const cacheText = localStorage.getItem(bridgeKey);
      localStorage.removeItem(bridgeKey);
      if (!cacheText) {
        this.handleBridgeError("跳转登录凭证已失效，请重新发起操作");
        return;
      }
      let loginInfo = null;
      try {
        loginInfo = JSON.parse(cacheText);
      } catch (error) {
        this.handleBridgeError("跳转登录数据解析失败，请重新发起操作");
        return;
      }
      if (!loginInfo || !loginInfo.token) {
        this.handleBridgeError("跳转登录数据不完整，请重新发起操作");
        return;
      }

      sessionStorage.clear();
      sessionStorage.setItem("area", loginInfo.staffAccountCountryOrRegionId || "");
      sessionStorage.setItem("role", loginInfo.roleName || "");
      sessionStorage.setItem(
        "roleNames",
        JSON.stringify(
          Array.isArray(loginInfo.roleNames)
            ? loginInfo.roleNames
            : loginInfo.roleName
            ? [loginInfo.roleName]
            : []
        )
      );
      sessionStorage.setItem("token", loginInfo.token || "");
      sessionStorage.setItem("name", loginInfo.staffName || "");
      sessionStorage.setItem("staffAccountId", loginInfo.staffAccountId || "");
      this.$store.state.userInfo = loginInfo;
      setSession("menu", loginInfo.permission || []);

      if (
        Array.isArray(loginInfo.permission) &&
        loginInfo.permission.indexOf("dataManage:get") !== -1
      ) {
        await Promise.all([
          this.getBasicData().catch(() => {}),
          this.getCountryList().catch(() => {})
        ]);
      }

      this.$router.replace("/");
    },
    async getBasicData() {
      const res = await basicLoad();
      if (res.status == 0) {
        if (res.data.dataManageCarModels.length > 0) {
          setSession("zdCar", res.data.dataManageCarModels);
        }
        if (res.data.dataManagePaymentTypes.length > 0) {
          setSession("zdPayType", res.data.dataManagePaymentTypes);
        }
        if (res.data.dataManagePaymentMethods.length > 0) {
          setSession("zdPayWay", res.data.dataManagePaymentMethods);
        }
      }
    },
    async getCountryList() {
      const res = await areaList();
      if (res.status != 0) {
        return;
      }
      const areaListData = [...res.data.area];
      const countryListData = [...res.data.countryOrRegion];
      let areaName = "";
      let countryName = "";
      const currentAreaId = sessionStorage.getItem("area");

      countryListData.forEach(item => {
        if (item.countryOrRegionId == currentAreaId) {
          countryName = item.countryOrRegionName;
          areaName = item.areaId;
        }
      });
      if (areaName && countryName) {
        areaListData.forEach(item => {
          if (item.areaId == areaName) {
            sessionStorage.setItem(
              "areaInfo",
              item.areaName + "大区——" + countryName
            );
          }
        });
      }
    },
    handleBridgeError(message) {
      this.loadingText = message;
      this.$DonMessage.error(message);
      setTimeout(() => {
        if (window.opener) {
          window.close();
          return;
        }
        this.$router.replace("/login");
      }, 1200);
    }
  }
};
</script>

<style scoped lang="scss">
.login-bridge {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #303133;
  background: #f5f7fa;
}

.loading-icon {
  font-size: 32px;
  color: #409eff;
  margin-bottom: 16px;
}

.loading-text {
  font-size: 16px;
  line-height: 24px;
}
</style>
